<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <v-card-title>
        <v-icon left>mdi-plus-box-multiple</v-icon>{{ $t('booking.add_booking_channel') }}
      </v-card-title>
      <v-card-text class="py-5">
        <span>{{ $t('booking.booking_channel') }}</span>
        <v-text-field
          :label="$t('booking.booking_channel')"
          :placeholder="$t('booking.booking_channel')"
          v-model="form.name"
          solo
          flat
          background-color="grey lighten-4"
        ></v-text-field>
      </v-card-text>
      <v-card-actions class="mx-3">
        <v-spacer></v-spacer>
        <v-btn color="error" elevation="0" @click="dialog = false">
          <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
        </v-btn>
        <v-btn
          color="success"
          elevation="0"
          @click="createBookingChannel() "
          :loading="isLoading"
          :disabled="form.name == ''"
        >
          <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AddBookingChannel",
  computed: {
    dialog: {
      get() {
        this.form = {
          name: ""
        };
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
      form: {
        name: ""
      },
      isLoading: false
    };
  },
  props: {
    value: Boolean,
    obj: Object
  },
  methods: {
    async createBookingChannel() {
      this.isLoading = true;
      const create = await this.$store.dispatch(
        "bookingChannel/createBookingChannel",
        {
          projectId: this.$store.getters["markets/getProjectId"],
          name: this.form.name
        }
      );
      this.form = {
        name: ""
      };
      this.$emit("onLoad");
      this.dialog = false;
      this.isLoading = false;
    }
  }
};
</script>
